import React, { Children, cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';

import InteractiveDiv from '../Wrapper/InteractiveDiv';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Accordion.module.css';

class AccordionItem extends PureComponent {
  state = {
    isExpanded: this.props.expanded
  };

  handleClick = () => {
    this.setState(state => ({
      isExpanded: !state.isExpanded
    }));
  };

  render() {
    const { children, headline, arrow, className } = this.props;
    const { isExpanded } = this.state;

    return (
      <div styleName="item" className={className}>
        <InteractiveDiv styleName="header" handler={this.handleClick}>
          <span>{headline}</span>
          {!arrow && <span>{isExpanded ? '➖' : '➕'}</span>}
          {arrow && (
            <i
              className="fl-navigate_next"
              styleName={isExpanded ? 'open-arrow' : 'closed-arrow'}
            />
          )}
        </InteractiveDiv>
        {isExpanded && <div styleName="body">{children}</div>}
      </div>
    );
  }
}

const WrappedAccordionItem = DisplayComponent(AccordionItem);

WrappedAccordionItem.propTypes = {
  /** Display with expanded body */
  expanded: PropTypes.bool,
  /** Content of header */
  headline: PropTypes.string.isRequired
};

const Accordion = ({ children, classes, expandAll }) => (
  <div className={classes} styleName="container">
    {Children.map(children, child => {
      return cloneElement(child, { ...child.props, expanded: expandAll });
    })}
  </div>
);

const WrappedAccordion = DisplayComponent(Accordion);

WrappedAccordion.propTypes = {
  /** Any amount of AccordionItems */
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([AccordionItem])
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf([AccordionItem])
      })
    )
  ]).isRequired,
  /** Initialize with all entries expanded */
  expandAll: PropTypes.bool
};

export default WrappedAccordion;
export { WrappedAccordionItem as AccordionItem };
